import React from "react"
import SettingsVcb from "./Settings/SettingsVcb";

const OptionsVcb = () => {
    return (
        <>
            <h3>Nastavení</h3>
            <SettingsVcb />
        </>
    )

}

export default OptionsVcb
